import { type CohortBuilderDefinitionLegacy } from './cohortBuilderLegacy';

export enum ResearchAssistantMessageEnumLegacy {
  INFO = 'info',
  SAVE = 'save',
  PROCESS = 'process',
  MODEL_CHANGE = 'model_change',
}

export type MessageLegacy = {
  message: React.ReactNode;
  timestamp?: string;
  currentUser: string;
  isCurrentUser: boolean;
  userInitials?: string;
  cohortDefinition?: CohortBuilderDefinitionLegacy; // TODO: update with CohortBuilderDefinition
  type?: ResearchAssistantMessageEnumLegacy;
  modelVersion?: string;
};
